import React from 'react';
import LoadingPlaceholderBlock from "../common/LoadingPlaceholderBlock";
import styles from "./Styles.module.css";
import CircularProgress from '@mui/material/CircularProgress';

/**
 * @author Okpala Oluchukwu Chioma <oluchukwu@chatdesk>
 */

const SearchLoading = () => {

    return(
        <div className={styles.loadingContainer}>
            <div className="margin-bottom-10">
                <LoadingPlaceholderBlock width={'100px'} height={'24px'} borderRadius={'3px'}/>
            </div>
            <div className={styles.mb10}>
                <LoadingPlaceholderBlock height={'50px'} borderRadius={'3px'}/>
            </div>
            <div className={styles.circularProgress}>
                <CircularProgress sx={{color: '#003300'}} />
            </div>
            <div className={`color-black-fade ${styles["floatMt10"]}`}>
                <LoadingPlaceholderBlock height={'50px'} width={'100px'} borderRadius={'3px'}/>
            </div>
        </div>
    );
};

export {SearchLoading}